export default {
  description: "please check back at a later date",
  endResults: "end of results",
  noResults: "no results"
};
